module.exports = __webpack_public_path__ + "static/julie-grant-lg-ca52cc88095fc7e67966a2d314cbf2e6.png";